export const helpOptionsModel: Array<{ [key: string]: string }> = [
    {
        alt: 'help_center_first_button_two',
        title: 'help_center_first_button_two',
        imageUrl: '/assets/images/help/card-1.png',
        titleCard: 'help_center_first_button_two',
        description: 'help_center_first_button_two_description',
        linkCard: 'https://blog.saldo.com.ar'
    },
    {
        alt: 'help_center_second_button_two',
        title: 'help_center_second_button_two',
        imageUrl: '/assets/images/help/card-2.png',
        titleCard: 'help_center_second_button_two',
        description: 'help_center_second_button_two_description',
        linkCard: '/ayuda#faq'
    },
    {
        alt: 'help_center_third_button_two',
        title: 'help_center_third_button_two',
        imageUrl: '/assets/images/help/card-3.png',
        titleCard: 'help_center_third_button_two',
        description: 'help_center_third_button_two_description',
        linkCard: 'https://www.instagram.com/saldo.ar/'
    }
];
export const warrantyOptionsModel: Array<{ [key: string]: string }> = [
    {
        alt: 'scams_title',
        title: 'scams_title',
        imageUrl: '/assets/images/warranty/garantia-estafas.png',
        titleCard: 'scams_title',
        description: 'scams_description'
    },
    {
        alt: 'increase_in_quotation',
        title: 'increase_in_quotation',
        imageUrl: '/assets/images/warranty/garantia-aumento.png',
        titleCard: 'increase_in_quotation',
        description: 'increase_in_quotation_info_text'
    },
    {
        alt: 'drop_in_quotation_title',
        title: 'drop_in_quotation_title',
        imageUrl: '/assets/images/warranty/garantia-aumento_1.png',
        titleCard: 'drop_in_quotation_title',
        description: 'drop_in_quotation_info_text'
    }
];
export const referralProgramWikiOptionsModel: Array<{ [key: string]: string }> = [
    {
        alt: 'win_usd_first_title',
        title: 'win_usd_first_title',
        imageUrl: '/assets/images/programa-de-referidos/referrals-paso1.png',
        titleCard: 'win_usd_first_title',
        description: 'win_usd_first_info_text'
    },
    {
        alt: 'win_usd_second_title',
        title: 'win_usd_second_title',
        imageUrl: '/assets/images/programa-de-referidos/referrals-paso2.png',
        titleCard: 'win_usd_second_title',
        description: 'win_usd_second_info_text'
    },
    {
        alt: 'win_usd_third_title',
        title: 'win_usd_third_title',
        imageUrl: '/assets/images/programa-de-referidos/referrals-paso3.png',
        titleCard: 'win_usd_third_title',
        description: 'win_usd_third_info_text'
    }
];
export const aboutUsMissionsAndValuesModel: Array<{ [key: string]: string }> = [
    {
        alt: 'customer_s_title',
        title: 'customer_s_title',
        imageUrl: '/assets/images/press/calidez-humana.png',
        titleCard: 'customer_s_title',
        description: 'customer_s_info'
    },
    {
        alt: 'symplicity_title',
        title: 'symplicity_title',
        imageUrl: '/assets/images/press/simplicidad.png',
        titleCard: 'symplicity_title',
        description: 'symplicity_info'
    },
    {
        alt: 'transparency_title',
        title: 'transparency_title',
        imageUrl: '/assets/images/press/transparencia.png',
        titleCard: 'transparency_title',
        description: 'transparency_info'
    },
    {
        alt: 'innovation_title',
        title: 'innovation_title',
        imageUrl: '/assets/images/press/innovacion.png',
        titleCard: 'innovation_title',
        description: 'innovation_info'
    }
];
